(function () {
  'use strict';
  /* @ngdoc object
   * @name crewViolations
   * @description
   *
   */
  angular
    .module('rosterStatusReportRadarChart', [
      'ui.router'
    ]);
}());
